import { Component, OnDestroy, PLATFORM_ID, inject } from "@angular/core";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { assetsConst } from "src/app/core/const/assets.const";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
} from "@angular/forms";
import { Subject, takeUntil } from "rxjs";
import { REGEX } from "src/app/core/const/regex.constant";
import { MustMatch } from "src/app/core/helpers/must-match.validator";
import { AuthService } from "src/app/core/services/auth.service";
import { SpinnerService } from "src/app/core/services/spinner.service";
import { ToasterService } from "src/app/core/services/toastr.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { LoginComponent } from "../login/login.component";
import { checkValidator } from "src/app/core/helpers/checkpasswordPatternvalidation.helper";
import { passwordFormErrors } from "src/app/core/const/passwordFormErrors.const";
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";

@Component({
  selector: "megastore-reset-password",
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
  ],
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnDestroy {
  hiddenNewPasswordVisibility = true;
  hiddenConfirmPasswordVisibility = true;
  submitted = false;
  resetPasswordFormGroup: FormGroup;
  destroy$: Subject<boolean> = new Subject<boolean>();
  assetsConst = assetsConst;
  checkValidations = checkValidator;
  formErrors = passwordFormErrors;
  private platFormId = inject(PLATFORM_ID);

  constructor(
    private formBuilder: FormBuilder,
    private _authService: AuthService,
    private _spinnerService: SpinnerService,
    private _toasterService: ToasterService,
    private _translateService: TranslateService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ResetPasswordComponent>
  ) {
    this.resetPasswordFormGroup = this.formBuilder.group(
      {
        newPassword: [
          "",
          [Validators.required, Validators.pattern(REGEX.Password)],
        ],
        confirmPassword: ["", Validators.required],
      },
      { validators: MustMatch("newPassword", "confirmPassword") }
    );
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.resetPasswordFormGroup.valid) {
      this._spinnerService.addToLoader("resetPassword");
      this._authService
        .resetPassword(this.resetPasswordFormGroup.value)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            if (isPlatformBrowser(this.platFormId)) {
              this._spinnerService.removeFromLoader("resetPassword");
              this._toasterService.successToastr(
                this._translateService.instant("resetPassSuccess")
              );
              localStorage.clear();
              this.dialogRef.close();
              this.dialog.open(LoginComponent, {
                panelClass: ["modall", "login_nodal"],
              });
            }
          },
          error: () => {
            this._spinnerService.removeFromLoader("resetPassword");
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}
